import React from 'react'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined'
import VisibilityOffOutlined from '@mui/icons-material/VisibilityOffOutlined'
import IconButton from '@mui/material/IconButton'
import './PasswordInput.scss'
import PropTypes from 'prop-types'

export const PasswordInput = ({
  value,
  onChange,
  onKeyPress,
  error,
  helperText,
  label,
  sx,
  fullWidth
}) => {
  const [showPassword, setShowPassword] = React.useState(false)
  const handleClickShowPassword = () => setShowPassword((show) => !show)

  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      value={value}
      onChange={onChange}
      onKeyPress={onKeyPress}
      error={error}
      helperText={helperText}
      fullWidth={fullWidth}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              edge="end"
              sx={{ color: 'white' }}
            >
              {showPassword ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
            </IconButton>
          </InputAdornment>
        )
      }}
      label={label}
      sx={sx}
    />
  )
}

PasswordInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  label: PropTypes.string,
  sx: PropTypes.object
}
